export default __webpack_public_path__ + "static/media/Youtube-icon.c76e4b01.svg";